<template>
  <el-dialog
    title="補單結果"
    :visible.sync="isVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="content">
      <div class="title">
        出單機狀態
      </div>
      <div v-if="printersWithStatusAndResult.length===0" class="printer-no-ip">
        <div class="el-icon el-icon-error"></div>
        <div>
          列印失敗，出單機目前尚未設置IP位址<br />
          請聯絡<span>智生活客服專線412-8166 (手機請加區碼)</span> 完成設定再進行補單。
        </div>
      </div>
      <div v-else>
        <div
          v-for="item in printersWithStatusAndResult"
          :key="item.Ip"
          class="printer-status"
        >
          <div
            class="el-icon"
            :class="[item.IsFulfilled ? 'el-icon-success' : 'el-icon-error']"
          />
          <span class="deviceName">{{ item.Remark }}：</span>
          <span class="status">{{ item.Result }}</span>
        </div>
      </div>
    </div>
    <el-button
      type="primary"
      @click="isVisible = false"
    >
      確認
    </el-button>
  </el-dialog>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      required: true
    },
    isNeedRefresh: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isVisible: false,
      printersWithStatusAndResult: []
    }
  },
  methods: {
    handleClose () {
      this.isVisible = false
      if (!this.isNeedRefresh) return
      let url
      if (process.env.NODE_ENV === 'development') {
        url = `${window.location.origin}/point/${this.path}`
      } else {
        url = `${window.location.origin}/mgmt/point/${this.path}`
      }
      window.location.href = url
    },
    setVal (val) {
      this.printersWithStatusAndResult = val
      this.isVisible = true
    }
  }

}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    @include basicDialog();
    .title {
      font-size: map-get($fontSize, 'large');
      font-weight: bold;
    }
    .el-icon{
      padding-right: 5px;
      &.el-icon-success {
        color: $mainColor;
      }
      &.el-icon-error {
        color: $dangerColor;
      }
    }
    .content {
      text-align: start;
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding-bottom: 35px;
    }
    .printer-no-ip{
      display: flex;
      color:$mainFontColor;
      line-height: 1.5rem;
      .el-icon{
        display: flex;
        align-items: center;
        height: 1.5rem;
      }
      span{
        color: $mainColor;
      }
    }
  }
</style>
